angular.module('core')
    .directive('phoneInput', function ($timeout, PhoneInputI18n, PhoneNumberFormatter) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                inputId: '@?',
                inputName: '@?',
                required: '<?',
                disabled: '<?',
                allowInvalid: '<?',
                allowInvalidOptIn: '<?',
                defaultCountry: '@?',
                preferredCountries: '<?',
                placeholder: '@?'
            },
            bindToController: true,
            controllerAs: '$ctrl',
            templateUrl: 'app/utils/phone-input/phone-input.html',
            controller: function () {
                this.defaultPreferredCountries = ['pl', 'de', 'gb', 'ua', 'cz']

                this.$onInit = () => {
                    this.required = this.required === true
                    this.disabled = this.disabled === true
                    this.allowInvalid = this.allowInvalid === true
                    this.allowInvalidOptIn = this.allowInvalidOptIn === true
                    this.allowInvalidSelected = false
                    this.preferredCountries = angular.isArray(this.preferredCountries) && this.preferredCountries.length
                        ? this.preferredCountries
                        : this.defaultPreferredCountries
                }

                this.getDefaultCountry = () => this.defaultCountry || 'pl'

                this.getCurrentCountryCode = () => {
                    let countryCode = this.getDefaultCountry()
                    if (this.iti && typeof this.iti.getSelectedCountryData === 'function') {
                        let selectedCountry = this.iti.getSelectedCountryData()
                        if (selectedCountry && selectedCountry.iso2) {
                            countryCode = selectedCountry.iso2
                        }
                    }
                    return countryCode
                }

                this.parseCurrentPhoneNumber = rawValue => {
                    if (!rawValue || PhoneNumberFormatter.isFreeTextValue(rawValue)) {
                        return null
                    }
                    return PhoneNumberFormatter.parsePhoneNumber(rawValue, this.getCurrentCountryCode())
                }

                this.isAcceptablePhoneNumber = rawValue => {
                    let parsedPhoneNumber = this.parseCurrentPhoneNumber(rawValue)
                    if (!parsedPhoneNumber) {
                        return false
                    }

                    let isValid = typeof parsedPhoneNumber.isValid === 'function' && parsedPhoneNumber.isValid()
                    if (isValid) {
                        return true
                    }

                    return typeof parsedPhoneNumber.isPossible === 'function' && parsedPhoneNumber.isPossible()
                }

                this.hasSelectedCountry = () => {
                    if (!this.iti || typeof this.iti.getSelectedCountryData !== 'function') {
                        return false
                    }

                    let selectedCountry = this.iti.getSelectedCountryData()
                    return !!(selectedCountry && selectedCountry.iso2)
                }

                this.getModelValue = () => {
                    let directModelValue = this.getDirectModelValue()
                    if (directModelValue !== '') {
                        return directModelValue
                    }

                    if (!this.ngModelCtrl) {
                        return ''
                    }

                    let viewValue = this.ngModelCtrl.$viewValue
                    if (!this.ngModelCtrl.$isEmpty(viewValue)) {
                        return String(viewValue).trim()
                    }

                    let modelValue = this.ngModelCtrl.$modelValue
                    if (!this.ngModelCtrl.$isEmpty(modelValue)) {
                        return String(modelValue).trim()
                    }

                    return ''
                }

                this.getDirectModelValue = () => {
                    if (!this.readBoundModel) {
                        return ''
                    }

                    let directModelValue = this.readBoundModel()
                    return angular.isDefined(directModelValue) && directModelValue !== null
                        ? String(directModelValue).trim()
                        : ''
                }

                this.formatDisplayValue = rawValue => {
                    let countryCode = this.getDefaultCountry()
                    if (this.iti && typeof this.iti.getSelectedCountryData === 'function') {
                        let selectedCountry = this.iti.getSelectedCountryData()
                        if (selectedCountry && selectedCountry.iso2) {
                            countryCode = selectedCountry.iso2
                        }
                    }

                    return PhoneNumberFormatter.formatForDisplay(rawValue, countryCode)
                }

                this.formatInputValue = rawValue => {
                    let countryCode = this.getDefaultCountry()
                    if (this.iti && typeof this.iti.getSelectedCountryData === 'function') {
                        let selectedCountry = this.iti.getSelectedCountryData()
                        if (selectedCountry && selectedCountry.iso2) {
                            countryCode = selectedCountry.iso2
                        }
                    }

                    return PhoneNumberFormatter.formatForInput(rawValue, countryCode)
                }

                this.formatTypingValue = rawValue => {
                    let countryCode = this.getDefaultCountry()
                    if (this.iti && typeof this.iti.getSelectedCountryData === 'function') {
                        let selectedCountry = this.iti.getSelectedCountryData()
                        if (selectedCountry && selectedCountry.iso2) {
                            countryCode = selectedCountry.iso2
                        }
                    }

                    return PhoneNumberFormatter.formatAsYouType(rawValue, countryCode)
                }

                this.formatValueForSelectedCountry = rawValue => {
                    if (PhoneNumberFormatter.isFreeTextValue(rawValue)) {
                        return rawValue
                    }

                    let countryCode = this.getDefaultCountry()
                    if (this.iti && typeof this.iti.getSelectedCountryData === 'function') {
                        let selectedCountry = this.iti.getSelectedCountryData()
                        if (selectedCountry && selectedCountry.iso2) {
                            countryCode = selectedCountry.iso2
                        }
                    }

                    let parsedPhoneNumber = PhoneNumberFormatter.parsePhoneNumber(rawValue, countryCode)
                    if (parsedPhoneNumber && parsedPhoneNumber.nationalNumber) {
                        return PhoneNumberFormatter.formatForInput(parsedPhoneNumber.nationalNumber, countryCode)
                    }

                    return PhoneNumberFormatter.formatForInput(rawValue, countryCode)
                }

                this.renderRawValue = rawValue => {
                    if (!this.input) {
                        return
                    }

                    this.input.disabled = this.disabled === true
                    this.input.value = this.formatInputValue(rawValue)
                }

                this.renderModelValue = () => {
                    let modelValue = this.getModelValue()

                    if (!modelValue) {
                        if (this.iti) {
                            this.iti.setNumber('')
                            if (typeof this.iti.setCountry === 'function') {
                                this.iti.setCountry('')
                            }
                        }
                        this.renderRawValue('')
                        return
                    }

                    this.renderRawValue(modelValue)

                    if (!this.iti) {
                        return
                    }

                    if (typeof this.iti.setCountry === 'function') {
                        this.iti.setCountry('')
                    }

                    let parsedPhoneNumber = PhoneNumberFormatter.parsePhoneNumber(modelValue, this.getDefaultCountry())
                    if (parsedPhoneNumber && parsedPhoneNumber.number) {
                        this.iti.setNumber(parsedPhoneNumber.number)
                        if (!this.input.value || !this.input.value.trim()) {
                            this.renderRawValue(modelValue)
                        }
                        return
                    }

                    this.renderRawValue(modelValue)
                }

                this.normalizeModelValue = rawValue => {
                    if (!rawValue) {
                        return null
                    }

                    if (PhoneNumberFormatter.isFreeTextValue(rawValue)) {
                        return rawValue
                    }

                    let parsedPhoneNumber = this.parseCurrentPhoneNumber(rawValue)
                    if (parsedPhoneNumber && this.isAcceptablePhoneNumber(rawValue) && parsedPhoneNumber.number) {
                        return parsedPhoneNumber.number
                    }

                    return rawValue
                }

                this.applyInitialFormatting = rawValue => {
                    if (!this.iti || !rawValue) {
                        return
                    }

                    let parsedPhoneNumber = this.parseCurrentPhoneNumber(rawValue)
                    if (parsedPhoneNumber && this.isAcceptablePhoneNumber(rawValue) && parsedPhoneNumber.number) {
                        this.iti.setNumber(parsedPhoneNumber.number)
                        if (!this.input.value || !this.input.value.trim()) {
                            this.renderRawValue(rawValue)
                        }
                    }
                }

                this.canBypassValidation = () => this.allowInvalid === true || this.allowInvalidSelected === true

                this.isCurrentValueInvalid = () => {
                    let modelValue = this.getModelValue()
                    if (!modelValue) {
                        return false
                    }
                    return !this.isAcceptablePhoneNumber(modelValue)
                }

                this.shouldShowAllowInvalidOption = () => {
                    if (this.allowInvalidOptIn !== true) {
                        return false
                    }
                    return this.isCurrentValueInvalid()
                }

                this.onAllowInvalidChanged = () => {
                    if (this.ngModelCtrl) {
                        this.ngModelCtrl.$validate()
                    }
                }

                this.validatePhone = modelValue => {
                    if (!this.ngModelCtrl) {
                        return true
                    }

                    if (this.canBypassValidation()) {
                        return true
                    }

                    if (this.required !== true && this.ngModelCtrl.$isEmpty(modelValue)) {
                        return true
                    }
                    if (this.required === true && this.ngModelCtrl.$isEmpty(modelValue)) {
                        return false
                    }
                    return this.isAcceptablePhoneNumber(modelValue)
                }

                this.destroy = () => {
                    if (this.input) {
                        this.input.removeEventListener('input', this.onInputChanged)
                        this.input.removeEventListener('countrychange', this.onCountryChanged)
                        this.input.removeEventListener('blur', this.onBlurChanged)
                    }

                    if (this.iti) {
                        this.iti.destroy()
                    }
                }

                this.countPhoneAnchors = value => {
                    let matches = String(value || '').match(/[+\d]/g)
                    return matches ? matches.length : 0
                }

                this.findCaretPosition = (formattedValue, anchorCount) => {
                    if (!anchorCount) {
                        return 0
                    }

                    let matchedAnchors = 0
                    for (let i = 0; i < formattedValue.length; i++) {
                        if (/[+\d]/.test(formattedValue.charAt(i))) {
                            matchedAnchors += 1
                        }
                        if (matchedAnchors >= anchorCount) {
                            return i + 1
                        }
                    }

                    return formattedValue.length
                }

                this.restoreCaretPosition = (rawValue, formattedValue, caretPosition) => {
                    if (!this.input || typeof caretPosition !== 'number') {
                        return
                    }

                    let anchorCount = this.countPhoneAnchors(rawValue.slice(0, caretPosition))
                    let nextCaretPosition = this.findCaretPosition(formattedValue, anchorCount)
                    this.input.setSelectionRange(nextCaretPosition, nextCaretPosition)
                }

                this.ensureCountryForValue = rawValue => {
                    if (!this.iti || !rawValue || this.hasSelectedCountry()) {
                        return
                    }

                    if (PhoneNumberFormatter.isFreeTextValue(rawValue)) {
                        return
                    }

                    let parsedPhoneNumber = PhoneNumberFormatter.parsePhoneNumber(rawValue, this.getDefaultCountry())
                    if (parsedPhoneNumber && parsedPhoneNumber.country && typeof this.iti.setCountry === 'function') {
                        this.iti.setCountry(parsedPhoneNumber.country.toLowerCase())
                        return
                    }

                    if (!PhoneNumberFormatter.isInternationalNumber(rawValue) && typeof this.iti.setCountry === 'function') {
                        this.iti.setCountry(this.getDefaultCountry())
                    }
                }
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                let ctrl = scope.$ctrl
                ctrl.ngModelCtrl = ngModelCtrl
                ctrl.readBoundModel = () => scope.$parent.$eval(attrs.ngModel)
                ctrl.host = element[0]
                ctrl.input = ctrl.host.querySelector('input')
                ctrl.runNgChange = () => {
                    if (attrs.ngChange) {
                        scope.$parent.$evalAsync(attrs.ngChange)
                    }
                }

                ctrl.onInputChanged = () => {
                    let rawValue = ctrl.input.value ? ctrl.input.value.trim() : ''
                    ctrl.ensureCountryForValue(rawValue)
                    let caretPosition = ctrl.input.selectionStart
                    let formattedValue = ctrl.formatTypingValue(rawValue)
                    if (formattedValue !== rawValue) {
                        ctrl.input.value = formattedValue
                        ctrl.restoreCaretPosition(rawValue, formattedValue, caretPosition)
                    }

                    let modelValue = ctrl.normalizeModelValue(ctrl.input.value ? ctrl.input.value.trim() : '')

                    scope.$evalAsync(() => {
                        ngModelCtrl.$setViewValue(modelValue)
                        ngModelCtrl.$validate()
                        ctrl.runNgChange()
                    })
                }

                ctrl.onCountryChanged = () => {
                    if (ctrl.input && ctrl.input.value) {
                        ctrl.input.value = ctrl.formatValueForSelectedCountry(ctrl.input.value)
                    }
                    ctrl.onInputChanged()
                }

                ctrl.onBlurChanged = () => {
                    let rawValue = ctrl.input && ctrl.input.value ? ctrl.input.value.trim() : ''
                    let parsedPhoneNumber = ctrl.parseCurrentPhoneNumber(rawValue)
                    if (ctrl.iti && parsedPhoneNumber && ctrl.isAcceptablePhoneNumber(rawValue) && parsedPhoneNumber.number) {
                        ctrl.iti.setNumber(parsedPhoneNumber.number)
                    }

                    if (!ctrl.input.value || !ctrl.input.value.trim()) {
                        ctrl.renderRawValue(ctrl.getModelValue())
                    }

                    ctrl.onInputChanged()
                }

                ngModelCtrl.$render = () => ctrl.renderModelValue()
                ngModelCtrl.$validators.phoneNumber = modelValue => ctrl.validatePhone(modelValue)

                if (typeof window.intlTelInput === 'function') {
                    ctrl.iti = window.intlTelInput(ctrl.input, {
                        initialCountry: '',
                        preferredCountries: ctrl.preferredCountries,
                        countrySearch: true,
                        countryOrder: ['pl', 'de', 'gb', 'ua', 'cz'],
                        formatAsYouType: false,
                        formatOnDisplay: false,
                        i18n: PhoneInputI18n.build(),
                        nationalMode: false,
                        separateDialCode: true,
                        allowedNumberTypes: ['MOBILE', 'FIXED_LINE', 'FIXED_LINE_OR_MOBILE'],
                        autoPlaceholder: 'aggressive',
                        strictMode: false
                    })
                }

                ctrl.input.addEventListener('input', ctrl.onInputChanged)
                ctrl.input.addEventListener('countrychange', ctrl.onCountryChanged)
                ctrl.input.addEventListener('blur', ctrl.onBlurChanged)

                ctrl.renderModelValue()
                $timeout(() => {
                    ctrl.renderModelValue()
                    ctrl.applyInitialFormatting(ctrl.getModelValue())
                }, 0)

                scope.$on('$destroy', () => ctrl.destroy())
            }
        }
    })
